
import React, { useState } from "react";
import navigate from "@helpers/link-navigate";
import useToggle from "hooks/useVehicleStylesToggle";
import Image from "components/image";
import Dropdown from "components/dropdowns/dropdown";
import getModulePadding from "helpers/get-module-padding";
import Link from "helpers/link";
import SrOnly from "../sr-only";
import CommonDropdown from "components/dropdowns/common-dropdown";
import ModalDropdown from "components/dropdowns/modal-dropdown";
import NProgress from "nprogress";

const VehicleLinks = ({
    style,
    isMobile,
    isOpen,
    stylesPerRowSettings,
    itemIndex,
    selectedLinkTitle
}) => {
    if (!style?.links) {
        return <div />;
    }

    const containerClassName = isMobile
        ? "md:hidden flex flex-col ml-4 mt-4 z-0"
        : "vehicle-style-links z-0";

    return (
        <div className={containerClassName}>
            <p className="text-gray-701 text-xs font-semibold">{style?.linksTitle}</p>
            <SrOnly label={`${selectedLinkTitle || style?.linksTitle} dropdown`} />
            <div className="flex flex-col">
                {style?.links?.map((link) => (
                    <Link
                        key={link?.title}
                        to={link?.url}
                        className={`${itemIndex > stylesPerRowSettings.hiddenLinksElementStyling
                            ? isOpen
                                ? ""
                                : "pointer-events-none"
                            : ""
                            } relative text-gray-701 text-xs font-semibold my-1 pl-4 z-50 before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-gray-701 before:rounded-1/2`}
                    >
                        {link?.title}
                    </Link>
                ))}
            </div>
        </div>
    );
};

const DesktopVehicleLinks = ({
    style,
    isOpen,
    stylesPerRowSettings,
    itemIndex,
    selectedLinkTitle,
    setSelectedLinkTitle,
}) => (
    <VehicleLinks
        style={style}
        isMobile={false}
        isOpen={isOpen}
        stylesPerRowSettings={stylesPerRowSettings}
        itemIndex={itemIndex}
        selectedLinkTitle={selectedLinkTitle}
        setSelectedLinkTitle={setSelectedLinkTitle}
    />
);

const MobileVehicleLinks = ({
    style,
    isOpen,
    stylesPerRowSettings,
    itemIndex,
    selectedLinkTitle,
    setSelectedLinkTitle,
}) => (
    <VehicleLinks
        style={style}
        isMobile
        isOpen={isOpen}
        stylesPerRowSettings={stylesPerRowSettings}
        itemIndex={itemIndex}
        selectedLinkTitle={selectedLinkTitle}
        setSelectedLinkTitle={setSelectedLinkTitle}
    />
);

const VehicleStylesShowcase = ({
    data: { title, stylesPerRow, styles, useDropdowns },
}) => {
    const { isOpen, toggle } = useToggle();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedLinkTitle, setSelectedLinkTitle] = useState(null);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [dropdownsOpen, setDropdownsOpen] = useState(null);

    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };



    // Grid is 3 columns on desktop, so 2 rows = 6 items. Hide the rest until See More.
    const collapsedVisibleCount = 6;

    const stylesPerRowSettings = {
        width: stylesPerRow === 4 ? "xl:w-[23.8%]" : "xl:w-[32%]",
        showSeeMoreButton: collapsedVisibleCount,
        hiddenLinksElementStyling: collapsedVisibleCount - 1,
        extraBottomMargin: stylesPerRow === 3 && "md:mt-14",
    };

    const handleSelectLink = (property, selectedValue, links) => {
        if (selectedValue) {
            let selectedItem = links.find((value) => value.title === selectedValue);
            if (selectedItem) {
                setSelectedLinkTitle(selectedValue);
                NProgress.start();
                navigate(selectedItem.url);
            }
        }
    };

    return (
        <div className="styles-section mx-auto container pb-4">
            <div className="styles-section__inner">
                <h3 className="styles-section__title">
                    {title}
                    <SrOnly label={title} />
                </h3>
                <div>
                    <div
                        className={`vehicle-style-items`}
                    >
                        {styles.map((style, index) => (
                            <div
                                tabIndex={0}
                                role="button"
                                onClick={() => setDropdownsOpen(dropdownsOpen === style?._key ? null : style?._key)}
                                aria-label={`${style?.title} ${style?.subtitle}`}
                                key={style?._key}
                                className={`vehicle-style-item ${index >= collapsedVisibleCount && !isOpen ? "vehicle-style-item--hidden" : ""} ${dropdownsOpen === style?._key ? "vehicle-style-item--dropdowns-open" : ""}`}
                            >
                                {/* {useDropdowns ? (
                                    <div className="vehicle-style-item__title">
                                        {style?.image?.url ? (
                                            <Link to={style?.image?.url} className="font-medium">
                                                {style?.title}
                                            </Link>
                                        ) : (
                                            <p className="font-medium text-center">{style?.title}</p>
                                        )}
                                        {style?.subtitle && (
                                            <p className="font-medium">{style?.subtitle}</p>
                                        )}
                                    </div>
                                ) : null} */}


                                {style?.image?.url ? (
                                    <Link to={style?.image?.url} className="z-0 vehicle-style-item__image" tabIndex={-1}>
                                        <Image
                                            image={style?.image?.asset}
                                            className="z-0"
                                            tabIndex={-1}
                                            removeSrcset
                                        />
                                    </Link>
                                ) : (
                                    <div className="z-0 vehicle-style-item__image">
                                        <Image image={style?.image?.asset} className="z-0" removeSrcset />
                                    </div>
                                )}
{/* 
                                {useDropdowns ? null : (
                                    <div className={`flex flex-row gap-1 items-center justify-center text-blue-700 font-medium mb-2`}>
                                        {style?.image?.url ? (
                                            <Link to={style?.image?.url} className="font-medium text-center px-4">
                                                {style?.title}
                                            </Link>
                                        ) : (
                                            <p className="font-medium text-center px-4">{style?.title}</p>
                                        )}
                                        {style?.subtitle && (
                                            <p className="font-medium">{style?.subtitle}</p>
                                        )}
                                    </div>
                                )} */}


                                {style?.links?.length > 0 && (
                                    <div className="vehicle-style-item__dropdowns">
                                        <SrOnly label={`style?.linksTitle} dropdown`} />
                                        {useDropdowns ? (
                                            <>
                                                <div className="hidden grow lg:block">
                                                    {/* <CommonDropdown
                                                        selected={style?.linksTitle}
                                                        options={style.links}
                                                        optionProperty="title"
                                                        onSelect={(property, selectedValue) =>
                                                            handleSelectLink(
                                                                property,
                                                                selectedValue,
                                                                style.links
                                                            )
                                                        }
                                                        hasSearch
                                                        disabled={false}
                                                        className="vehicle-style-item__dropdown"
                                                        key={`links-dropdown-${index}`}
                                                    /> */}
                                                    <Dropdown
                                                        options={style.links}
                                                        isOpen={dropdownsOpen === style?._key}
                                                        placeholder={style?.title + " " + (style?.subtitle ? " " + style?.subtitle : "")}
                                                        onOpenChange={(isOpen) => setDropdownsOpen(isOpen ? style?._key : null)}
                                                        onOptionSelect={(option) => handleSelectLink(null, option.title, style.links)}
                                                    />
                                                </div>

                                                {/* MOBILE DROPDOWN */}
                                                <div className="vehicle-style-item__mobile-dropdown block lg:hidden">
                                                    <ModalDropdown
                                                        selected={style?.title + " " + (style?.subtitle ? " " + style?.subtitle : "")}
                                                        options={style.links}
                                                        optionProperty="title"
                                                        onSelect={(property, selectedValue) =>
                                                            handleSelectLink(
                                                                property,
                                                                selectedValue,
                                                                style.links
                                                            )
                                                        }
                                                        hasSearch
                                                        disabled={false}
                                                        isOpen={openDropdownIndex === index}
                                                        toggle={() => toggleDropdown(index)}
                                                        key={`links-modal-dropdown-${index}`}
                                                        onOpen={() => setOpenDropdownIndex(index)}
                                                        onGoBack={() => setOpenDropdownIndex(null)}
                                                        showModal={openDropdownIndex === index}
                                                        className="lg:hidden flex"
                                                    />
                                                </div>
                                                {/* <button
                                                    type="button"
                                                    disabled={!selectedLinkTitle}
                                                    className="transition-all duration-300 font-normal md:text-base text-base-xs flex hover:text-white hover:bg-orange-800 focus:bg-orange-800 focus:text-white bg-orange-703 lg:w-20 w-full lg:h-11 h-8 rounded-lg items-center justify-center"
                                                    onClick={() =>
                                                        handleSelectLink(
                                                            null,
                                                            style.links[0].title,
                                                            style.links
                                                        )
                                                    }
                                                >
                                                    Go
                                                </button> */}
                                            </>
                                        ) : (
                                            <>
                                                <DesktopVehicleLinks
                                                    style={style}
                                                    isOpen={isOpen}
                                                    stylesPerRowSettings={stylesPerRowSettings}
                                                    itemIndex={index}
                                                    selectedLinkTitle={selectedLinkTitle}
                                                    setSelectedLinkTitle={setSelectedLinkTitle}
                                                />
                                                <MobileVehicleLinks
                                                    style={style}
                                                    isOpen={isOpen}
                                                    stylesPerRowSettings={stylesPerRowSettings}
                                                    itemIndex={index}
                                                    selectedLinkTitle={selectedLinkTitle}
                                                    setSelectedLinkTitle={setSelectedLinkTitle}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                                {!style?.links?.length > 0 && (
                                    <Link to={style?.image?.url} className="vehicle-style-item__no-links">
                                        <p className="vehicle-style-item__no-links-title">
                                            {style?.title + " " + (style?.subtitle ? " " + style?.subtitle : "")}
                                        </p>
                                        <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.749999 0.75L4.75 6.75L0.75 12.75" stroke="#00344E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </Link>
                                )}
                            </div>
                        ))}
                    </div>
                    {styles?.length > stylesPerRowSettings.showSeeMoreButton && (
                        <div
                            className={`vehicle-style__show-more-wrapper ${isOpen ? "hidden" : ""
                                }`}
                        >
                            <button
                                type="button"
                                className="vehicle-style__show-more-button"
                                onClick={toggle}
                                onKeyDown={toggle}
                            >
                                See More
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div >
    );
};

export default VehicleStylesShowcase;
